/**
 * Purchase Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PurchaseOrderReturnPageItemVO { 
    id?: number;
    code?: string;
    poCode?: string;
    vendorId?: number;
    vendorCode?: string;
    vendorName?: string;
    warehouseId?: number;
    warehouseCode?: string;
    warehouseName?: string;
    reason?: string;
    status?: PurchaseOrderReturnPageItemVO.StatusEnum;
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
}
export namespace PurchaseOrderReturnPageItemVO {
    export const StatusEnum = {
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Rejected: 'REJECTED',
        InProgress: 'IN_PROGRESS',
        PartiallyShipped: 'PARTIALLY_SHIPPED',
        FullyShipped: 'FULLY_SHIPPED',
        ReceivedByVendor: 'RECEIVED_BY_VENDOR',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


